// Module 1: Fact Extraction.
// The agent's system prompt (server side) defines the JSON schema and output rules.
// This file builds the user message containing the file content.

const MAX_CHARS = 80_000; // ~20k tokens, well under Claude's context window

export function buildFactExtractionMessage({ text, fileName, pages, fileType }) {
  const truncated = text.length > MAX_CHARS;
  const body = truncated ? text.slice(0, MAX_CHARS) : text;

  return `KYC/CDD FILE: ${fileName || 'untitled'}
FILE TYPE: ${fileType || 'unknown'}
PAGES: ${pages ?? 'unknown'}
CHARS: ${text.length}${truncated ? ` (truncated to ${MAX_CHARS} for processing)` : ''}

--- BEGIN FILE CONTENT ---
${body}
--- END FILE CONTENT ---

Extract the facts. Return only the JSON object specified in your instructions.`;
}
